import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition, faChevronDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mayne-nav-element',
  templateUrl: './nav-element.component.html',
  styleUrls: ['./nav-element.component.scss']
})
export class NavElementComponent {


  @Input() text: string = '';
  @Input() icon: IconProp | string | null = null;
  @Input() children: any[] | null = null;
  @Input() path: string = '';
  @Input() active: boolean = false;

  faIcon: boolean = false;
  theFaIcon: IconProp | null = null;

  showChildren: boolean = false;

  faChevron = faChevronDown;

  ngOnInit() {
    this.setIconType();
  }

  ngOnChanges() {
    console.log('CHENGES');
    this.setIconType();
  }

  setIconType() {
    if (!this.icon) {
      this.faIcon = false;
      return;
    }
    this.faIcon = !(typeof this.icon === "string");

    if (this.faIcon) {
      this.theFaIcon = this.icon as IconProp;
    }
  }
  @Output() clickEvent = new EventEmitter<string>();


  onClick(event: any) {
    this.clickEvent.emit(this.path);
  }

}
